import { wxuser } from '@/api/base';
import { Dialog } from 'vant';
import router from '../router';
function isVip(type) {
  return new Promise(function(resolve, reject) {
    //type=1 //盯盘会员  2 发帖会员
    wxuser().then(res => {
      let sta = alertDig(type, res);
      resolve(sta);
    });
  });
}

export async function asyncIsVip(type, key, obj) {
  let status = false;
  if (key == 'noFetch') {
    status = alertDig(type, obj);
  } else {
    await isVip(type).then(res => {
      status = res;
    });
  }
  return status;
}

function alertDig(type, res) {
  let now = new Date().getTime();
  if (type == 2) {
    let r = res.data.vipInfos.filter(function(x) {
      return x.vipType == 3;
    });

    if (r && r.length > 0 && now < new Date(r[0].validityTime).getTime()) {
      return true;
    } else {
      Dialog.confirm({
        title: '暂未开通一尘发帖助手会员',
        confirmButtonText: '开通会员',
        cancelButtonText: '取消',
      })
        .then(() => {
          router.push({
            path: '/vip',
            query: { r: encodeURIComponent(encodeURIComponent(window.location.href)) },
          });
        })
        .catch(() => {
          console.log(router);
          // on cancel
          if (router.currentRoute.name === 'score' || router.currentRoute.path === '/score') {
            router.go(-1);
          }
        });
      return false;
    }
  }
}
